import React from 'react';
import Checkbox from '@/components/core/Checkbox';

const FormikCheckbox = ({ field, ...props }) => {
    return (
      <Checkbox
        {...field}
        {...props}
        checked={field.value}
      />
    );
};

export default FormikCheckbox;
